import {type FormEventHandler} from 'react';
import {FormattedMessage} from 'react-intl';
import {Dialog, type DialogProps, DialogTitle, DialogContent, Grid, Typography} from '@mui/material';
import {useFormState} from 'hooks';
import {SaveButton} from 'components/buttons';
import {ElevatedInput} from 'components/inputs';
import {Alert} from 'components/feedbacks';

type EditBookmarkFolderDialogProps = DialogProps & {
  handleEditFolder: Function;
  submitting: boolean;
  folderName: string;
  errorReason?: string;
}

const EditBookmarkFolderDialog = ({folderName, open, onClose, handleEditFolder, submitting, errorReason} : EditBookmarkFolderDialogProps) : JSX.Element => {
  const [values, onChange] = useFormState({
    newFolderName: folderName
  });

  const handleSubmit : FormEventHandler<HTMLFormElement> = event => {
    event.preventDefault();
    if (newFolderName === folderName) onClose(event, "backdropClick");
    else handleEditFolder(values);
  }

  const {newFolderName} = values;
  return <Dialog open={open} onClose={onClose} fullWidth>
    <form onSubmit={handleSubmit}>
      <DialogTitle>
        <Grid container justifyContent='space-between' alignItems='center'>
          <Grid item>
            <Grid container alignItems='center'>
              <Typography variant='h6' color='primary'>
                <FormattedMessage id='admin.bookmarks.folder.update.title' values={{ folderName }} />
              </Typography>
            </Grid>
          </Grid>
          <Grid item>
            <SaveButton className="bg-admin-blue-400" type='submit' loading={submitting} />
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={4}>
          <Grid item xxs={12}>
            <ElevatedInput
              label='Nom'
              name='newFolderName'
              value={newFolderName}
              onChange={onChange}
              required
              fullWidth
              autoFocus
            />
          </Grid>
        </Grid>
      {errorReason && <Alert>
        <Typography><FormattedMessage id={'admin.bookmarks.action.failed.' + errorReason} /></Typography>
      </Alert>}
      </DialogContent>
    </form>
  </Dialog>
}

export default EditBookmarkFolderDialog;